export default {
    install: (app, options: { lang: string; currency?: string }) => {
        app.config.globalProperties.toFixedLocal = (number: number) => {
            const formatter = new Intl.NumberFormat(options.lang, {
                style: 'currency',
                currency: options.currency ?? currencyFromLocale(options.lang),
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });

            return formatter.format(number);
        };
    },
};

function currencyFromLocale(locale: string): string {
    if (locale.startsWith('de')) return 'EUR';
    if (locale.startsWith('nl')) return 'EUR';
    return 'EUR'; // default
}
